'use client';

import dynamic from 'next/dynamic';
import { memo, useState } from 'react';
import { SlidersHorizontal } from 'lucide-react';
import { Button } from '@upzi/web-shell/ui/button';
import { cn } from '@/lib/utils';
import { getActiveJobFilterGroupCount } from '../filter-config';
import type { MobileJobFilterSheetProps } from './mobile-job-filter-sheet';
import {
  MOBILE_JOB_FILTER_TRIGGER_ACTIVE_CLASSNAME,
  MOBILE_JOB_FILTER_TRIGGER_CLASSNAME,
} from './mobile-job-filter-trigger-styles';

const MobileJobFilterSheet = dynamic(
  () =>
    import('./mobile-job-filter-sheet').then(
      module => module.MobileJobFilterSheet
    ),
  {
    ssr: false,
    loading: () => (
      <Button
        type="button"
        variant="outline"
        disabled
        className={MOBILE_JOB_FILTER_TRIGGER_CLASSNAME}
      >
        <SlidersHorizontal className="size-4" aria-hidden />
        Đang tải…
      </Button>
    ),
  }
);

export const LazyMobileJobFilterSheet = memo(function LazyMobileJobFilterSheet(
  props: MobileJobFilterSheetProps
) {
  const [isActivated, setIsActivated] = useState(false);

  if (isActivated) {
    return <MobileJobFilterSheet {...props} defaultOpen />;
  }

  const activeFilterCount = getActiveJobFilterGroupCount(props.filters);

  return (
    <Button
      type="button"
      variant="outline"
      onClick={() => setIsActivated(true)}
      className={cn(
        MOBILE_JOB_FILTER_TRIGGER_CLASSNAME,
        activeFilterCount > 0 && MOBILE_JOB_FILTER_TRIGGER_ACTIVE_CLASSNAME
      )}
    >
      <SlidersHorizontal className="size-4" aria-hidden />
      <span>
        Bộ lọc{activeFilterCount > 0 ? ` (${activeFilterCount})` : ''}
      </span>
    </Button>
  );
});
